import { t } from "@/i18n-js/instance";
import { STATUS } from "@circle-react/helpers/communityMemberChargeHelpers";

export const RESULTS_PER_PAGE = 10;

export const TABS = {
  ALL: "all",
  PAID: "paid",
  PROCESSING: "processing",
  REFUNDED: "refunded",
  FAILED: "failed",
} as const;

export type TabType = (typeof TABS)[keyof typeof TABS];

export const TABS_LOCALE: Record<TabType, string> = {
  [TABS.ALL]: t("settings.paywalls_admin_dashboard.charges.tabs.all"),
  [TABS.PROCESSING]: t(
    "settings.paywalls_admin_dashboard.charges.tabs.processing",
  ),
  [TABS.PAID]: t("settings.paywalls_admin_dashboard.charges.tabs.paid"),
  [TABS.REFUNDED]: t("settings.paywalls_admin_dashboard.charges.tabs.refunded"),
  [TABS.FAILED]: t("settings.paywalls_admin_dashboard.charges.tabs.failed"),
};

export const statusByTab: Record<TabType, string | null> = {
  [TABS.ALL]: null,
  [TABS.PAID]: [STATUS.PAID, STATUS.PARTIAL_REFUNDED].join(","),
  [TABS.PROCESSING]: STATUS.PROCESSING,
  [TABS.REFUNDED]: STATUS.REFUNDED,
  [TABS.FAILED]: STATUS.FAILED,
};
